import React, { useEffect, useState } from "react";
import { useParams ,useNavigate} from "react-router-dom";
import {
  Avatar,
  Form,
  Input,
  Button,
  Spin,
  Tag,
  Select,
  DatePicker
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

function InstructorDetails() {
  const { id } = useParams();
 
   const navigate = useNavigate();
  
    // Auth info
    const token = localStorage.getItem("token");
    const fullName = localStorage.getItem("fullName");
    const role = (localStorage.getItem("role") || "").toUpperCase();
  
    useEffect(() => {
      if (!token || !fullName || !role) {
        navigate("/user/sign_in");
      }
    }, [token, fullName, role, navigate]);
    
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [form] = Form.useForm();
  const [activeSection, setActiveSection] = useState("personal");
    const [saving, setSaving] = useState(false);

  useEffect(() => {
    const loadInstructor = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/instructor/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.success) {
  const data = res.data.data;

  setUser(data);

  form.setFieldsValue({
    ...data,
    JoinedDate: data.JoinedDate ? dayjs(data.JoinedDate) : null,
  });
}
      } finally {
        setLoading(false);
      }
    };

    loadInstructor();
  }, [id, token, form]);

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <Spin size="large" />
      </div>
    );

  if (!user)
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        Instructor not found
      </div>
    );

  const sectionButton = (key, label) => (
    <button
      onClick={() => setActiveSection(key)}
      className={`w-full text-left px-5 py-3 rounded-xl font-medium transition 
        ${
          activeSection === key
            ? "bg-indigo-600 text-white shadow-md"
            : "text-gray-600 hover:bg-indigo-50"
        }`}
    >
      {label}
    </button>
  );



const handleUpdateInstructor = async () => {
  try {
    setSaving(true);

    const values = await form.validateFields();

const payload = {
  Email: user.Email,
  ...values,
  JoinedDate: values.JoinedDate
    ? values.JoinedDate.format("YYYY-MM-DD")
    : null,
};
    const response = await axios.put(
  `${process.env.REACT_APP_API_URL}/user/instructor/update`,
  payload,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
);

    if (response.data.success) {
      toast.success("Instructor updated successfully 🎯");
      setUser(response.data.data);
    } else {
      toast.error(response.data.message);
    }

  } catch (error) {
    toast.error(error?.response?.data?.message || "Update failed ❌");
  } finally {
    setSaving(false);
  }
};

  return (
    <div className="min-h-screen bg-gray-100">

      <ToastContainer
                    position="bottom-left"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                    className="!mb-6 !ml-4"
                    toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                  />

      {/* ===== HEADER ===== */}
      <div className="px-12 py-10 m-2 text-white shadow-lg bg-gradient-to-r from-indigo-600 to-rose-500 rounded-3xl">
        <div className="flex flex-col items-center gap-6 md:flex-row">

          <Avatar
            size={110}
            src={user.ProfilePhotoUrl}
            icon={<UserOutlined />}
            className="border-4 border-white shadow-lg"
          />

          <div>
            <h1 className="text-3xl font-bold">
              {user.FullName}
            </h1>

            <p className="opacity-90">
              {user.Email}
            </p>

            <div className="flex gap-3 mt-4">
              <Tag color="geekblue">{user.Role}</Tag>
              <Tag
                color={
                  user.InstructorStatus === "ACTIVE"
                    ? "green"
                    : "red"
                }
              >
                {user.InstructorStatus}
              </Tag>
            </div>
          </div>

        </div>
      </div>

      {/* ===== MAIN GRID ===== */}
      <div className="grid grid-cols-1 gap-10 px-12 py-12 lg:grid-cols-4">

        {/* LEFT MENU */}
        <div className="p-6 space-y-4 bg-white shadow-md rounded-3xl">
          {sectionButton("personal", "Personal Information")}
          {sectionButton("professional", "Professional Details")}
          {sectionButton("bank", "Bank Information")}
        </div>

        {/* RIGHT CONTENT */}
        <div className="p-10 bg-white shadow-md rounded-3xl lg:col-span-3">

          <Form
            form={form}
            layout="vertical"
            className="text-gray-700"
          >

            {/* PERSONAL */}
            {activeSection === "personal" && (
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <Form.Item name="FullName" label="Full Name">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="Email" label="Email">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="PhoneNumber" label="Phone Number">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="Country" label="Country">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="PanCardNumber" label="PAN Card Number">
                  <Input size="large" />
                </Form.Item>

                 <Form.Item name="AadharCardNumber" label="Aadhar Card Number">
                  <Input size="large" />
                </Form.Item>
                
                <Form.Item
                  name="JoinedDate"
                  label={<span className="font-semibold text-slate-700">Joined Date</span>}
                  rules={[{ required: true, message: "Please select joined date" }]}
                >
                  <DatePicker
                    size="large"
                    className="w-full rounded-lg"
                    format="DD-MM-YYYY"
                  />
                </Form.Item>
                
              </div>
            )}

            {/* PROFESSIONAL */}
            {activeSection === "professional" && (
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <Form.Item name="Domain" label="Domain">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="ProgramName" label="Program Name">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="PreviousCompany" label="Previous Company">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="Experience" label="Experience (Years)">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="InstructorStatus" label="Instructor Status">
                  <Select size="large">
                    <Select.Option value="ACTIVE">ACTIVE</Select.Option>
                    <Select.Option value="INACTIVE">INACTIVE</Select.Option>
                  </Select>
                </Form.Item>
              </div>
            )}

            {/* BANK */}
            {activeSection === "bank" && (
              <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                <Form.Item name="BankAccountHolderName" label="Account Holder Name">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="BankAccountNumber" label="Account Number">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="BankName" label="Bank Name">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="BankBranch" label="Bank Branch">
                  <Input size="large" />
                </Form.Item>

                <Form.Item name="IFSCCode" label="IFSC Code">
                  <Input size="large" />
                </Form.Item>
              </div>
            )}

            <Button
  type="primary"
  size="large"
  loading={saving}
  onClick={handleUpdateInstructor}
  className="px-10 mt-8 !bg-indigo-600 hover:!bg-indigo-700 rounded-xl font-semibold"
>
  Update Instructor
</Button>

          </Form>

        </div>

      </div>
    </div>
  );
}

export default InstructorDetails;